var _circle, _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrantAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#00893F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#00893F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#00893F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 17.1516L14.1457 12.3518C13.7557 12.0086 13.1694 11.9054 12.6594 12.0914C12.1507 12.2774 11.818 12.7154 11.818 13.2002V16.8H6.36361C5.6109 16.8 5 17.3376 5 18C5 18.6624 5.6109 19.2 6.36361 19.2H11.818V22.7998C11.818 23.2846 12.1507 23.7226 12.6594 23.9086C13.1694 24.0946 13.7557 23.9914 14.1457 23.6482L19.6001 18.8484C20.1333 18.3792 20.1333 17.6208 19.6001 17.1516Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantAccess);
export default __webpack_public_path__ + "static/media/grant-access.30e9bb47.svg";
export { ForwardRef as ReactComponent };